export default {

  init() {

    $('[data-track-open]').on('click', function(e) {
      e.preventDefault();
      Track.open();
    });

    $('[data-track-close]').on('click', function(e) {
    	e.preventDefault();
    	Track.close();
    });

  },

  open() {
  	let $track = $('.hero__track');

    $track.toggleClass('is-active');
    $track.find('input[type=text]').first().focus();
    $('html').toggleClass('is-track-open');

    Track.onClickOutside();
    Track.onEscape();
  },

  close() {
  	let $track = $('.hero__track');

    $track.removeClass('is-active');
    $track.find('input[type=text]').first().blur();
    $('html').removeClass('is-track-open');

    $(document).off('keyup.track');
    $(window).off('click.track');
		$('.hero__track').off('click.nav');
  },

  onClickOutside() {
  	$('.hero__track').on('click.track', function(e) {
  		e.stopPropagation();
  	});

  	$(window).on('click.track', function(e) {
  		Track.close();
  	});
  },

  onEscape() {
  	function escapeKey(e) {
      if (e.keyCode === 27) {
        Track.close();
      }
    }

    $(document).on('keyup.track', escapeKey);
  },

};
